import connectivityMonitorMessages from
  'ringcentral-integration/modules/ConnectivityMonitor/connectivityMonitorMessages';

export default {
  [connectivityMonitorMessages.disconnected]: 'Network connection is lost.',
};
